import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  requestWorkers,
  RequestWorkersPayload,
} from 'api/assignment/requestWorkers'
import { assignmentKeys } from './keys'
interface UseRequestWorkersParams {
  companyId: number
  assignmentId: number
}

export const useRequestWorkersMutation = ({
  companyId,
  assignmentId,
}: UseRequestWorkersParams) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: RequestWorkersPayload) =>
      requestWorkers(companyId, assignmentId, payload),
    onSuccess: async () => {
      // Invalidate and wait for the new data to be fetched
      await queryClient.invalidateQueries({
        queryKey: assignmentKeys.detail.byId(assignmentId),
        refetchType: 'active', // Only refetch active queries
      })
    },
  })
}
